import { UserInfoContext } from '@app/collections/fortress/UserInfoContext'
import { Col, Collapse, CollapsePanel, Radio, Row, Text } from '@app/components'
import { IStore } from '@app/redux'
import { getEntity, getSingle } from '@app/services'
import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { RevolutIcon, WiseIcon, ZellePayIcon } from '~public'
import { OGPLogo } from '~public/icons/OGPLogo'

import { ACHPullContent, CryptoDepositContent, WireTransferContent, WiseTransferContent } from './panels-contents'
import { IntlTransfer } from './panels-contents/intl-transfer'
import { OGBPayContent } from './panels-contents/ogb-pay'
import { RevolutTransferContent } from './panels-contents/revolut-transfer'
import { ZellePayContent } from './panels-contents/zelle-pay'

export const PaymentMethodCollapse: React.FC<any> = ({
  //fund,
  //setFund,
  selectedPanel,
  setSelectedPanel,
  wireTransactionType,
  setWireTransactionType,
  //selectedMethod,
  //setSelectedMethod,
  setCurrentNode,
  stablecoinType,
  setStablecoinType,
  handleImageSave,
  stablecoinBalance,
}) => {
  const [userMemo, setUserMemo] = useState('Loading...')

  const { user } = useSelector((state: IStore) => state)
  const { usa, ogp, mtl, fetchUserInfo } = useContext(UserInfoContext)

  useEffect(() => {
    const fetchCountry = async () => {
      const single = user.selectedEntityName
        ? await getEntity(user.selectedEntityIdentityId)
        : await getSingle(user.uid)
      //console.log(single)
      setUserMemo(single.memo)
    }

    fetchCountry()
    fetchUserInfo()
  }, [])

  // setWireTransactionType('wire-instructions') if usa==true
  useEffect(() => {
    if (usa) {
      setWireTransactionType('wire-instructions')
    } else {
      setWireTransactionType('wire-instructions-intl')
    }
  }, [usa])

  return (
    <Collapse activeKey={[selectedPanel]} expandIcon={({ isActive }) => <Radio checked={isActive} />}>
      {usa == true && (
        <>
          <CollapsePanel
            header={
              <Header
                title={'Old Glory Pay (Instant / $5k limit per day)'}
                description="ACH / Wire / Debit or Credit & Direct Deposit options"
              />
            }
            key="2"
            onClick={() => setSelectedPanel('2')}
            extra={<OGPLogo style={{ height: 50, width: 75 }} />}
          >
            <OGBPayContent setCurrentNode={setCurrentNode} userMemo={userMemo} />
          </CollapsePanel>
          {(!ogp || mtl == 0) && (
            <CollapsePanel
              header={<Header title={'Zelle Pay'} description="Zelle Deposit option" />}
              key="9"
              onClick={() => setSelectedPanel('9')}
              extra={<ZellePayIcon style={{ height: 50, width: 50 }} />}
            >
              <ZellePayContent setCurrentNode={setCurrentNode} userMemo={userMemo} />
            </CollapsePanel>
          )}
        </>
      )}

      {usa != true && (
        <>
          <CollapsePanel
            header={<Header title={'Local Bank Transfer (Recommended)'} description="Local transfer options" />}
            key="8"
            onClick={() => setSelectedPanel('8')}
          >
            <IntlTransfer userMemo={userMemo} />
          </CollapsePanel>
        </>
      )}

      {(!ogp || mtl == 0 || usa != true) && (
        <>
          <CollapsePanel
            header={
              <Header
                title={'Wire transfer'}
                description="Use wire transfer to deposit money into your digital account"
              />
            }
            key="1"
            onClick={() => setSelectedPanel('1')}
          >
            <WireTransferContent
              wireTransactionType={wireTransactionType}
              setWireTransactionType={setWireTransactionType}
              setCurrentNode={setCurrentNode}
              handleImageSave={handleImageSave}
              userMemo={userMemo}
            />
          </CollapsePanel>

          <CollapsePanel
            header={<Header title={'ACH push'} description="Use ACH push to deposit money into your digital account" />}
            key="3"
            onClick={() => setSelectedPanel('3')}
          >
            <ACHPullContent
              //wireTransactionType={wireTransactionType}
              //setWireTransactionType={setWireTransactionType}
              //setCurrentNode={setCurrentNode}
              //handleImageSave={handleImageSave}
              userMemo={userMemo}
            />
          </CollapsePanel>

          <CollapsePanel
            header={<Header title={'Wise'} description="ACH / Wire / Debit or Credit & Direct Deposit options" />}
            key="4"
            onClick={() => setSelectedPanel('4')}
            extra={<WiseIcon style={{ height: 40, width: 40 }} />}
          >
            <WiseTransferContent setCurrentNode={setCurrentNode} userMemo={userMemo} />
          </CollapsePanel>

          <CollapsePanel
            header={<Header title={'Revolut'} description="ACH / Wire / Debit or Credit & Direct Deposit options" />}
            key="6"
            onClick={() => setSelectedPanel('6')}
            extra={<RevolutIcon style={{ height: 40, width: 40 }} />}
          >
            <RevolutTransferContent setCurrentNode={setCurrentNode} userMemo={userMemo} />
          </CollapsePanel>

          <CollapsePanel
            header={<Header title={'Ethereum Stablecoin Deposit'} description="Swap your ETH Stablecoins" />}
            key="5"
            onClick={() => setSelectedPanel('5')}
          >
            <CryptoDepositContent
              stablecoinType={stablecoinType}
              setStablecoinType={setStablecoinType}
              setCurrentNode={setCurrentNode}
              stablecoinBalance={stablecoinBalance}
            />
          </CollapsePanel>
        </>
      )}
    </Collapse>
  )
}

const Header = ({ title, description }) => {
  return (
    <Row gutter={[0, 0]}>
      <Col span={24}>
        <Text>{title}</Text>
      </Col>
      <Col span={24}>
        <Text disabled>{description}</Text>
      </Col>
    </Row>
  )
}
